import mantlePlugin from '@exodus/mantle-plugin';
import mantleSepoliaPlugin from '@exodus/mantlesepolia-plugin';
export const mantle = mantlePlugin;
export const mantlesepolia = mantleSepoliaPlugin;
